import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Background } from './components/Background';
import { Selector } from './components/Selector';
import { Station } from './components/Station';
import { StationName } from './components/StationName';
import { includesAll } from './utils/includesAll';
export var UndergroundMapV2 = function UndergroundMapV2(_ref) {
  var data = _ref.data,
      selectedStations = _ref.selectedStations,
      onRemove = _ref.onRemove,
      onSelect = _ref.onSelect;
  var _data$meta = data.meta,
      w = _data$meta.w,
      h = _data$meta.h,
      bg = _data$meta.bg;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      ready = _React$useState2[0],
      setReady = _React$useState2[1];

  var handleReady = React.useCallback(function () {
    return setReady(true);
  }, []);
  var toggleStationFactory = React.useCallback(function (stationId) {
    return function () {
      if (selectedStations.includes(stationId)) {
        onRemove([stationId]);
      } else {
        onSelect([stationId]);
      }
    };
  }, [selectedStations, onRemove, onSelect]);
  var toggleLineFactory = React.useCallback(function (lineId) {
    return function () {
      var lineStations = data.stations.filter(function (station) {
        return station.lineId === lineId;
      }).map(function (station) {
        return station.id;
      });

      if (includesAll(selectedStations, lineStations)) {
        onRemove(lineStations);
      } else {
        onSelect(lineStations);
      }
    };
  }, [data.stations, onRemove, onSelect, selectedStations]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "map-v2",
    style: {
      width: "".concat(w, "px"),
      height: "".concat(h, "px"),
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(Background, {
    width: w,
    height: h,
    slices: bg,
    onReady: handleReady
  }), ready && data.stations.map(function (station) {
    return /*#__PURE__*/React.createElement(Station, _extends({
      key: "station-".concat(station.lineId, "-").concat(station.id),
      onClick: toggleStationFactory(station.id),
      active: selectedStations.includes(station.id)
    }, station));
  }), ready && data.stationNames.map(function (stationName) {
    return /*#__PURE__*/React.createElement(StationName, _extends({
      key: "station-name=".concat(stationName.lineId, "-").concat(stationName.id),
      onClick: toggleStationFactory(stationName.id),
      active: selectedStations.includes(stationName.id)
    }, stationName));
  }), ready && data.selectors.map(function (selector, index) {
    return /*#__PURE__*/React.createElement(Selector, _extends({
      key: "selector-".concat(selector.lineId, "-").concat(index),
      onClick: toggleLineFactory(selector.lineId)
    }, selector));
  }));
};